import React from 'react';

interface FadeElementProps {
  children: React.ReactNode;
  // Define any other props you might want to pass
}

const FadeElement: React.FC<FadeElementProps> = (props) => {
  const { children, ...transitionProps } = props;
  return <div {...transitionProps}>{children}</div>;
};

export default FadeElement;
